module.exports = __webpack_public_path__ + "img/Starbucks_case_study_1.78a405d5.jpg";